import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
import * as expandableSectionActions from '~/actions/expandableSection';
import ArtifactViewMainContentTechnicalTeardownInformation from '~/artifact/containers/ArtifactViewMainContentTechnicalTeardownInformation';
type ArtifactViewMainContentTechnicalDetailsProps = {
  actions: object;
  artifactState: object;
  expandableSectionState: object;
  artifact: object;
};
class ArtifactViewMainContentTechnicalDetails extends React.Component<
  ArtifactViewMainContentTechnicalDetailsProps,
  {}
> {
  render() {
    const { artifact = {} } = this.props;
    return (
      <div>
        <div className="font--16 font-family--gotham-bold text--bold color--muted-dark pb- bo-b--1 border-color--white-dark mb-">
          Teardown
        </div>
        <div className="col-1-1">
          <ArtifactViewMainContentTechnicalTeardownInformation artifact={artifact} />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    expandableSectionState: state.expandableSectionState,
    myState: state.myState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...artifactActions, ...expandableSectionActions }, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentTechnicalDetails);
